import {AbstractControl, UntypedFormControl} from '@angular/forms';

export const hasNumberValidator = (control: UntypedFormControl): { [s: string]: boolean } => {
    const hasNumber = /[0-9]/.test(control.value);

    if (!hasNumber && control.value) {
        return {'hasNumberError': true};
    }
    return null;
};

export const hasUpperValidator = (control: UntypedFormControl): { [s: string]: boolean } => {
    const hasUpper = /[A-Z]/.test(control.value);

    if (!hasUpper && control.value) {
        return {'hasUpperError': true};
    }
    return null;
};

export const hasLowerValidator = (control: UntypedFormControl): { [s: string]: boolean } => {
    const value = control.value == undefined ? '' : control.value;
    const hasLower = /[a-z]/.test(value);

    if (!hasLower && control.value) {
        return {'hasLowerError': true};
    }
    return null;
};

export const hasCharacterValidator = (control: UntypedFormControl): { [s: string]: boolean } => {
    const hasCharacter = /[-!_@#%*^.()]/.test(control.value);

    if (!hasCharacter && control.value) {
        return {'hasCharacterError': true};
    }
    return null;
};

export const passwordHasNotAllowableCharacterValidator = (control: UntypedFormControl): { [s: string]: boolean } => {
    const hasNotAllowableCharacter = /[+]/.test(control.value);

    if (hasNotAllowableCharacter) {
        return {'passwordHasNotAllowableCharacterError': true};
    }
    return null;
};

export const confirmPasswordValidator = (control: AbstractControl): {[s: string]: boolean} => {
    if (control.value && control.parent.get('password') && (control.parent.get('password').value !== control.value)) {
        return {'hasConfirmPasswordError': true};
    }
};

export const PASSWORD_STRENGTH_INFO =
    'Password must be at least 10 characters and contain upper and lower case letters, numbers, and non-alphanumeric characters';
export const MIN_LENGTH_ERROR_MESSAGE = 'Password must be at least 10 characters';
export const PASSWORD_MATCH_MESSAGE = 'Passwords match:';
export const PASSWORD_MATCH_ERROR_MESSAGE = 'Passwords do not match';
export const PASSWORD__STRENGTH_COLORS = ['#DD2C00', '#FF6D00', '#FFD600', '#AEEA00', '#4caf50'];
export const MIN_PASSWORD_LENGTH = 10;
export const PASSWORD_STRENGTH_BAR_LABEL = 'Password strength:';
export const COPY_MESSAGE = 'Generated Password was copied to Clipboard';
export const PASSWORD_REQUIRED_MESSAGE = 'Please enter password';
export const CONFIRM_PASSWORD_REQUIRED_MESSAGE = 'Please confirm password';
export const EQUAL_TO_EMAIL_ERROR_MESSAGE = 'Password can not be equal to your email';
export const EQUAL_TO_USERNAME_ERROR_MESSAGE = 'Password can not be equal to username';
export const PASSWORD_CONTAIN_FORBIDDEN_CHARACTERS_MESSAGE = 'Password contains forbidden characters';
export const PASSWORD_ERROR_BODY_MESSAGE = 'Password must contain ';
export const DefaultPasswordErrorMessages = {
    hasNumberError: 'numbers',
    hasUpperError: 'upper case letters',
    hasLowerError: 'lower case letters',
    hasCharacterError: 'non-alphanumeric characters'
};
